import { useEffect, useState } from "react"
import * as Constants from "../../../constants/urls"
import { useCookies } from "react-cookie";
import axios from "axios";

export default function FormAdminBarcode(props){
    const [users , setUsers]=useState([])
    const [cookies, setCookie, removeCookie] = useCookies();

    function getAdmins() { 
        const url = Constants.apiUrl + "/api/getHasRoleUsers";
        axios
            .get(url, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((r) => {
                setUsers(r.data); 
            })
            .catch((e) => { 
            });
    }

    useEffect(()=>{
        getAdmins()
    },[])
     return(<>
    <div className=" p-4">
    <div className="row">
        <div className="col-md-4 text-right">
            <label>
                کاربر
            </label>
            <select className="form-control" name="userId" onChange={props.changeHandle}>
                <option>انتخاب کنید</option>
                {
                users.map((item)=>(<>
                <option value={item.id} selected={props.userId==item.id}>{item.name}</option>
                </>))
            }
            </select>
            
        </div>
        <div className="col-md-4 text-right">
            <label>
                بارکد
            </label>
           <input type="text" className="form-control" value={props.barcode} name="barcode"  onChange={props.changeHandle}/>
        </div>
        <div className="col-md-4 text-right">
            <label>
                وضعیت
            </label>
            <select className="form-control" name="status" onChange={props.changeHandle}>
            <option value={1} selected={props.status==1}>فعال</option>
            <option value={0} selected={props.status==0}>غیر‌فعال</option>
            </select>
        </div>
    </div>
    <hr/>
    <div>
        <button className="btn btn-block btn-success" onClick={props.click}>
            ثبت
        </button>
    </div>

    </div>
    </>)
}